import { Link } from "react-router-dom";
import { Droplets, PhoneCall, MessageCircle, Mail } from "lucide-react";
import { AZIENDA } from "@/lib/config";

export const Header = () => (
  <header className="sticky top-0 z-40 backdrop-blur-md bg-white/85 border-b border-slate-200/70" data-testid="site-header">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
      <Link to="/" className="flex items-center gap-2" data-testid="header-logo-link">
        <span className="w-9 h-9 rounded-xl bg-sky-600 text-white grid place-items-center">
          <Droplets className="w-5 h-5" />
        </span>
        <span className="leading-tight" data-testid="header-brand-name">
          <span className="block text-[10px] sm:text-xs font-bold uppercase tracking-wider text-sky-700">Interventi Idraulici</span>
          <span className="block font-extrabold tracking-tight text-base sm:text-lg">Andrea Morelli</span>
        </span>
      </Link>
      <nav className="hidden md:flex items-center gap-6 text-sm font-semibold text-slate-600">
        <a href="#servizi" className="hover:text-sky-700 transition-colors" data-testid="nav-servizi-link">Servizi</a>
        <a href="#caldaie" className="hover:text-sky-700 transition-colors" data-testid="nav-caldaie-link">Caldaie</a>
        <a href="#recensioni" className="hover:text-sky-700 transition-colors" data-testid="nav-recensioni-link">Recensioni</a>
        <a href="#richiesta" className="hover:text-sky-700 transition-colors" data-testid="nav-richiesta-link">Richiedi intervento</a>
        <Link to="/gestione" className="hover:text-sky-700 transition-colors" data-testid="nav-gestione-link">Area gestione</Link>
      </nav>
      <div className="flex items-center gap-2">
        <a href={AZIENDA.emailLink} className="hidden sm:grid w-10 h-10 place-items-center rounded-full border border-slate-200 hover:bg-slate-100 transition-colors" aria-label="Email" data-testid="header-email-btn">
          <Mail className="w-4 h-4" />
        </a>
        <a href={AZIENDA.whatsappLink} target="_blank" rel="noreferrer" className="hidden sm:grid w-10 h-10 place-items-center rounded-full bg-green-600 text-white hover:bg-green-700 transition-colors" aria-label="WhatsApp" data-testid="header-whatsapp-btn">
          <MessageCircle className="w-4 h-4" />
        </a>
        <a href={AZIENDA.telefonoLink} className="inline-flex items-center gap-2 rounded-full bg-orange-600 text-white px-4 h-10 text-sm font-bold hover:bg-orange-700 transition-colors" data-testid="header-call-btn">
          <PhoneCall className="w-4 h-4" /> <span className="hidden sm:inline">Chiama H24</span><span className="sm:hidden">H24</span>
        </a>
      </div>
    </div>
  </header>
);
